import React, { forwardRef } from 'react';
import { Modal, Box, useTheme } from '@mui/material';

interface DSContractModalProps
  extends Omit<React.ComponentProps<typeof Modal>, 'children'> {
  children: React.ReactNode;
}

const DSContractModal = forwardRef<HTMLDivElement, DSContractModalProps>(
  (props, ref) => {
    const { children, ...modalProps } = props;
    const { spacing, palette } = useTheme();

    return (
      <Modal {...modalProps}>
        <Box
          ref={ref}
          sx={{
            outline: null,
            position: 'absolute',
            width: { xxs: '100%', md: '90%' },
            height: { xxs: '100%', md: '90%' },
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: palette.background.default,
            borderRadius: { xxs: 0, md: spacing(1) },
            p: spacing(2),
            display: 'flex',
            flexDirection: 'column',
            gap: spacing(2),
          }}
        >
          {children}
        </Box>
      </Modal>
    );
  },
);

export default DSContractModal;
